













import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    debugInfo: {
      type: String,
      required: true,
    },
  },
});
